import { useEffect } from 'react';
import { initMetaPixel } from './lib/meta-pixel.js';
import { captureSourceOnce } from './lib/source-store.js';
import { AppRouter } from './pages/router.js';

export function App() {
  useEffect(() => {
    initMetaPixel();
    // Antes de qualquer navegação: é o único momento em que a URL ainda tem
    // os parâmetros do anúncio. Ver lib/source-store.ts.
    captureSourceOnce();
  }, []);

  return <AppRouter />;
}
